<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <h5>Emergency Services</h5>
        <hr />
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="card mini-stats-wid" @click="CallService(1, 'Ambulance')">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-6 col-12 text-center">
                <h1 class="text-muted" style="font-size: 50px">
                  <i class="mdi mdi-ambulance"></i>
                </h1>
              </div>

              <div class="col-lg-6 col-12 text-center font-size-14">
                Ambulance
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="card mini-stats-wid" @click="CallService(1, 'Police')">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-6 col-12 text-center">
                <h1 class="text-muted" style="font-size: 50px">
                  <i class="mdi mdi-police-badge"></i>
                </h1>
              </div>

              <div class="col-lg-6 col-12 text-center font-size-14">Police</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="card mini-stats-wid" @click="CallService(1, 'Crane')">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-6 col-12 text-center">
                <h1 class="text-muted" style="font-size: 50px">
                  <i class="mdi mdi-crane"></i>
                </h1>
              </div>

              <div class="col-lg-6 col-12 text-center font-size-14">Crane</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div
          class="card mini-stats-wid"
          @click="CallService(1, 'Water Tanker')"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-lg-6 col-12 text-center">
                <h1 class="text-muted" style="font-size: 50px">
                  <i class="mdi mdi-tanker-truck"></i>
                </h1>
              </div>

              <div class="col-lg-6 col-12 text-center font-size-14">
                Water Tanker
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div
          class="card mini-stats-wid"
          @click="CallService(1, 'Fire Brigade')"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-lg-6 col-12 text-center">
                <h1 class="text-muted" style="font-size: 50px">
                  <i class="mdi mdi-fire-truck"></i>
                </h1>
              </div>

              <div class="col-lg-6 col-12 text-center font-size-14">
                Fire Brigade
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div
          class="card mini-stats-wid"
          @click="CallService(1, 'JCB / Bulldozer')"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-lg-6 col-12 text-center">
                <h1 class="text-muted" style="font-size: 50px">
                  <i class="mdi mdi-bulldozer"></i>
                </h1>
              </div>

              <div class="col-lg-6 col-12 text-center font-size-14">
                JCB / Bulldozer
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "@/layouts/main";
import Swal from "sweetalert2";

export default {
  components: {
    Layout,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    CallService(serviceId, serviceName) {
      Swal.fire(
        "Informed!",
        `Your request for ${serviceName} has been sent to the operator`,
        "success"
      );
    },
  },
};
</script>